'use strict';

/**
 * Collection for shares
 *
 * @category   Collection
 * @module     share
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var ShareModel = require('../models/share');

var SharesCollection = Collection.extend({
    api: '/shares',
    name: 'shares',
    model: ShareModel,
});

module.exports = SharesCollection;